import React from 'react';
import s from './Spinner.module.scss';

export const Spinner = () => <div className={s.loader} />;
